/**
 * Optional YouTube video IDs for gallery items that only have an Aparat URL in the database.
 * Key: Aparat videohash (from URL). Value: YouTube video ID (not full URL).
 * Do not invent IDs — add entries only when an official YouTube equivalent exists.
 */
export const APARAT_TO_YOUTUBE: Record<string, string> = {
  // example: 'abcd1234': 'dQw4w9WgXcQ',
};
